var map = {
	"./blackJack.gif": 420,
	"./bolaMagica.gif": 4848,
	"./catBombers.gif": 8848,
	"./deliverymedia.gif": 5680,
	"./goodAndGo.gif": 4555,
	"./grandvoyage.gif": 9933,
	"./landingPage.gif": 4750,
	"./netflix.gif": 7340,
	"./weatherApp.gif": 5756
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6230;